<template>
    <div class="tab_box">
      <!-- 操作按钮 -->
      <list-btn @add="add" @del="del" @check="check" isCheck isAdd isDel ref="actionbtn"></list-btn>

      <!-- 新增弹窗 -->
      <el-dialog
        width="900px"
        customClass="dialog_detail_style"
        title="选择物料"
        :visible.sync="dialogSelectMatters"
        @close="cancelSelect"
        v-dialogDrag
      >
        <matter-stock-list
          class="contnet_box"
          ref="selectMatter"
          :searchCriteria="searchCriteria"
          :selectedList="selectedMatterSaleList"
          @getSelect="getSelect"
        ></matter-stock-list>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelSelect">取 消</el-button>
          <el-button type="primary" @click="selectMattersOk">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 物料核对信息新增弹窗 -->
      <el-dialog
        width="900px"
        customClass="dialog_detail_style"
        title="短缺料清单"
        :visible.sync="dialogSelectMatter"
        @close="cancelSelect"
        v-dialogDrag
      >
        <matter-check-list
          class="contnet_box"
          ref="selectMatter"
          :searchCriteria="searchCriteria"
          :selectedList="selectedMatterSaleList"
          @getSelect="getSelect"
        ></matter-check-list>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="selectCheckOk">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 错误的表格-->
      <!-- <el-button type="text" @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button> -->
      <!-- <el-dialog title="错误的上传数据" :visible.sync="isExcelError" width="900px">
      <tab-list :tabList="excelErrorList" :columns="excelErrorTabColumns" isno nheight="400">
      </tab-list>
      </el-dialog>-->

      <!-- 可编辑的表格 -->
      <!-- <edit-tab-list ref="editTabList" :columns="tabColums" :listArr="selectedMatterSale" style="width:100%;"></edit-tab-list> -->
      <vxe-table
        border
        resizable
        ref="editTabList"
        :data="selectedMatterProductOrders"
        :edit-config="{trigger: 'click', mode: 'cell',activeMethod: activeCellMethod}"
        @edit-disabled="editDisabledEvent" 
        @edit-actived="editActivedEvent" 
        @edit-closed="editClosedEvent"
      >
        <vxe-table-column type="checkbox" width="40"></vxe-table-column>
        <vxe-table-column
          field="bomProjectNo" 
          title="项目"
          width="110"
        ></vxe-table-column> 
        <vxe-table-column
          field="projectClassify"
          title="项目类别"
          width="140"
        ></vxe-table-column>
        <vxe-table-column
          field="bomComponent"
          title="组件"
          width="140"
        ></vxe-table-column>
        <vxe-table-column
          field="bomComponentDesc"
          title="组件描述"
          width="140"
        ></vxe-table-column>
        <vxe-table-column
          field="componentNum"
          title="数量"
          :edit-render="{name: 'input', attrs: {type: 'number'}}"
          onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
          width="140"
        ></vxe-table-column>
        <vxe-table-column
          field="compUnitDesc"
          title="计量单位"
          :edit-render="{name: 'select', options: targetUnitList,events:{change:changEvent}}"
          width="140"
        ></vxe-table-column>
        <!-- <vxe-table-column
          field="inventoryDesc"
          title="库存地点"
          :edit-render="{name: 'input', attrs: {type: 'text'}}"
          width="130"
        ></vxe-table-column> -->
        <vxe-table-column
          field="component"
          title="组装件"
          width="140"
        ></vxe-table-column>
        <vxe-table-column field="removeMark" title="删除标志" :edit-render="{name: 'input'}" width="140"></vxe-table-column>
        <vxe-table-column field="recoil" title="自动扣账标识" :edit-render="{name: 'input',events:{change:changRecoil}}" width="140"></vxe-table-column>
      </vxe-table>
    </div>
</template>
<script>
import {excelUpload,excelDownload} from 'api/excel.js'
import {targetUnit,productOrder} from 'api/business.js'

import listBtn from 'components/btn/listBtn.vue';
import matterStockList from 'components/matters/bomStockList.vue';
import matterCheckList from 'components/matters/checkStockList.vue';
import tabList from 'components/table/list.vue';
import editTabList from 'components/table/vxeTab.vue';

import { mapState, mapActions } from 'vuex'
export default{
	components:{ 
		listBtn,
    matterStockList,
    matterCheckList,
		tabList,
		editTabList
	},
  props:{
    fromData:Object,
    noFromData:Object,
  },
  computed:{
    ...mapState("cache",['selectedMatterProductOrders']),
    selectedMatterSaleList(){
      this.selectedMatterProductOrders.forEach((item,index)=>{
          if(!item.targetUnitId){
            item.targetUnitId = item.basicUnitId;
            item.targetUnit = item.basicUnitCode;
            item.targetUnitDesc = item.basicUnitDesc;
          }
        //console.log(this.selectedMatterProductOrders[0].componentNum)
      });
      return this.selectedMatterProductOrders;
    }
  },
	data(){
		return {
      tableData: [],
      sexList: [],
      targetUnitList:[],
      dialogSelectMatters:false,
      dialogSelectMatter:false,
	    searchCriteria:{},
      selectList:[],//所选数据
      selectedList:[],//已选数据
      sdata:{},//已选中的
      postExcelData:{},//EXCEL上传时所需传递的参数
      downloadUrl:excelDownload.saleOutStock,
      uploadUrl:excelUpload.saleOutStock,
      /* 错误的表格表头
      excelErrorTabColumns:[
        {field: 'excelRow', title: 'excel行号',width:100,"sortable":true},
        {field: 'errorDesc', title: '错误信息'},
        {field: 'materialCode', title: '物料编码',width:110},
        {field: 'materialDesc', title: '物料描述'},
        {field: 'quantity', title: '数量',width:50},
        {field: 'purchasePrice', title: '单价',width:50},
        {field: 'currencyCode', title: '币种',width:50},
        {field: 'basicUnitDesc', title: '基本单位',width:80},
        {field: 'specifications', title: '规格'},
        {field: 'projectTxt', title: '备注'}
      ],
      excelErrorList:[],
      isExcelError:false,//是否有上传错误的数据
      */
     /* 
      tabColums:[
        // {field:"null",title:"项目",width:100},
        {field:"materialCode",title:"物料编码",width:110},
        {field:"materialDesc",title:"物料描述",width:180},
        {field:"materialTypeName",title:"数量",isEdit:true,type:"input",width:80},
        {field:"basicUnitDesc",title:"计量单位",isEdit:true,type:"input",width:100},
       {field:"quantity",title:"数量",width:100,isEdit:true,oninput:function(row){
          if(row){
            console.log(row.availableStock,6666);
            let temp = row.quantity +'';
            temp = temp.replace(/[^\d]/g,'');
            if(temp >  row.availableStock) temp = row.availableStock;
            row.quantity = temp;
          }
        }}, 
        {field:"factoryDesc",title:"工厂",isEdit:true,type:"input",width:100},
        {field:"inventoryDesc",title:"库存地点",width:100,isEdit:true,type:"input"},
        {field:"date",title:"交货日期",isEdit:true,type:"date",width:80},
        
        {field: 'null', title: '销售价格',isEdit:true,type:"input",width: 100},
        {field:"taxml",title:"销项税",width:80,isEdit:true,type:"input"},
        {field:"materialGroup",title:"物料组",width:160},
      ]*/
		};
	},
   async created(){
     //有效起止日默认今天
    let nowData = new Date();
    this.$set(this.fromData, "startDate", nowData);
      // this.tableData = window.MOCK_DATA_LIST.slice(0, 6)
      this.findSexList()

      let targetUnitList = await this.$post(targetUnit.list,this.$store.state.getAllPage);
      console.log(targetUnitList,'8888888888');
      if(targetUnitList.status){
        this.targetUnitList = targetUnitList.data.list;
        this.targetUnitList.forEach((item)=>{
          item.label = item.unitDesc;
          item.value = item.unitDesc;
        });
      }
  },
  mounted: function () {
     this.$nextTick(function () {

     })
   },
   updated:function(){
   },
	methods:{
    findSexList () {  
            },
            editActivedEvent ({ row, column }, event) {
              console.log(`打开 ${column.title} 列编辑`)
            },
            editClosedEvent ({ row, column }, event) {
              console.log(`关闭 ${column.title} 列编辑`)
            },
    ...mapActions('cache',['setSelectedProductOrderMaterials']),
    activeCellMethod({ column, columnIndex }) {
      if (columnIndex === 1||columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 7) {
        return false;
      } 
      return true;
    },
    editDisabledEvent({ row, column }) {
      // this.$message.error("禁止编辑");
    },
		//选中数据
		selectSdata(data){
		  this.sdata = data;
		},
		//获取所选
		getSelect(res){
      console.log(res)
      this.selectList = res;
      //  this.sexList=res;
		},
    //新增弹窗确定所选
    selectMattersOk(){
      console.log(this.selectList)
      this.setSelectedProductOrderMaterials({
        "arr":this.selectList,
        other:{ 
          
        }
      });
      this.dialogSelectMatters = false;
    },
    //物料核对信息确定所选
    selectCheckOk(){
      console.log(this.selectList)
      this.setSelectedProductOrderMaterials({
        "arr":this.selectList,
        other:{ 
          "targetUnitDesc":this.fromData.targetUnitDesc,//基本计量单位
          "targetUnitCode":this.fromData.targetUnitCode,
          "targetUnitId":this.fromData.targetUnitId,
        }
      });
      this.dialogSelectMatter = false;
    },
    //取消所选v
    cancelSelect(){
      this.$refs.selectMatter.cancelSelect();
      this.dialogSelectMatters = false;
      this.dialogSelectMatter = false;

    },
    //新增按钮
    add(){
      this.dialogSelectMatters = true;return;
      if(!this.fromData.factoryCode){
    	this.$message.error('请选择工厂');
    	return false;
      }
      if(!this.fromData.inventoryCode){
        this.$message.error('请选择工厂库存地');
        return false;
      }
      if(!this.fromData.factoryCode){
        this.$message.error('请选择客户');
        return false;
      }
      this.searchCriteria.factoryId = this.fromData.factoryId;
      this.searchCriteria.inventoryId = this.fromData.inventoryId;
      this.dialogSelectMatters = true;
    },
		//删除
		del(){
      console.log(this.selectedMatterProductOrders,'==333==');
      let delList = this.$refs.editTabList.getCheckboxRecords();
      console.log(delList,'== 444 ==');
		  //this.getSelectEvent();
		 // let delList = this.$refs.editTabList.checkedList;
		  if(delList.length < 1){
		  this.$message.error('请选择需要删除的记录');
		  }else{
		    this.$confirm('确认删除已选数据, 是否继续?', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning'
		    }).then(() => {
		      delList.forEach((item)=>{
		      let nowIndex = this.selectedMatterProductOrders.findIndex(v=>v.materialId === item.materialId);
		      if(nowIndex != -1){
		        this.$store.state.cache.selectedMatterProductOrders.splice(nowIndex,1);
		      }
		      })
		    });
		  }
    },
    //物料核对信息
    async check(){
      // console.log(this.fromData)
      let res = await this.$post(productOrder.check, this.fromData);
      let json = JSON.stringify(this.fromData);
      console.log(json);
      console.log(res);
      this.$store.state.cache.CheckBomList = res.data.bomDto.bomComponents
      res.data.bomDto.bomComponents.map((item)=>{
          if (item.errorDesc == null) {
            this.$message.success('无短缺物料');
          } else {
            this.$message.error(item.errorDesc);
            // console.log()
            this.dialogSelectMatter = true;
          }
        });
      
    },
    //计量单位改变
    changEvent({row},event){
      console.log(event.target.value,"===13123231===",this.targetUnitList)
      let obj = this.targetUnitList.find(v=>v.unitDesc == event.target.value);
      console.log(obj)
      row.bomComponentId = obj.unitId;
      row.bomComponent = obj.unitCode;
      row.bomComponentDesc = obj.unitDesc;
      //alert(1);
      console.log(row,'===  666666666 ==',event);
    },
    //反冲标识改变
    changRecoil(val){
      console.log(val.data)
      this.$store.state.cache.selectedMatterProductOrders = val.data
    }
	}

}
</script>

<style>
</style>
